import { Component, inject, OnInit } from '@angular/core';
import { RouterLink, RouterOutlet } from '@angular/router';
import { NotificationStateService } from '../../domains/notifications/core/services/notification-state.service';
import { HeaderNavMenuComponent } from '../components/header-nav-menu/header-nav-menu.component';
import { NotificationBellComponent } from '../../domains/notifications/shared/components/notification-bell/notification-bell.component';
import { UserAvatarComponent } from '../components/user-avatar/user-avatar.component';
import { ToastOutletComponent } from '../components/toast-outlet/toast-outlet.component';

@Component({
  selector: 'app-dashboard-shell',
  imports: [RouterLink, RouterOutlet, HeaderNavMenuComponent, NotificationBellComponent, UserAvatarComponent, ToastOutletComponent],
  templateUrl: './dashboard-shell.component.html',
})
export class DashboardShellComponent implements OnInit {
  private readonly notificationState = inject(NotificationStateService);

  ngOnInit(): void {
    this.notificationState.initialize();
  }
}
